import React, { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from "react";
import { Unit } from "../../../types/enums/unit.enum";

interface LengthUnitContextInterface {
  unit: Unit;
  set: Dispatch<SetStateAction<Unit>>;
}

export const LengthUnitContext = createContext<LengthUnitContextInterface | null>(null);

const LengthUnitContextProvider = ({children} : PropsWithChildren) => {
  
  const [unit, setUnit] = useState<Unit>(Unit.MM);

  return (
    <LengthUnitContext.Provider value={{unit, set: setUnit}}>
      {children}
    </LengthUnitContext.Provider>
  )
}

export default LengthUnitContextProvider;